export const currentSchoolYear = "2026-2027";
